<mbs-wizard
  class="mbs-wizard_flex-content"
  [(ngModel)]="stepsManager.currentStep"
  [scrollableStepContent]="true"
  [buttonLoadingMode]="true"
  [canClosed]="!loadingPlan && wizardFinish"
  [firstStepTitle]="mainService.firstStepTitle"
  [isOpenSteps]="!loadingPlan && isEdit"
  [loading]="loadingPlan"
  [stepsOrientation]="orientations"
  [stepQueue]="stepsManager.stepQueue"
  [stepsContainerClass]="mainService.isOffline ? 'overflow-hidden' : ''"
  (closeModalEvent)="handleModalClose()"
  (save)="handleSave()"
  [title]="wizardTitle + ' ' + mainService.compName + ' | ' + (FormModel?.planNameStep?.Name || '')">
  <div
    *ngIf="mainService.isOffline"
    prependStep
    class="pl-4 py-2 background-secondary">
    <span class="fa fa-power-off"></span> {{ prependStepText }}
  </div>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.welcome"
    [title]="'wizards:welcome' | i18next"
    [valid]="FormModel?.planNameStep?.valid"
    (next)="planNameStep?.forceValid()">
    <mbs-plan-name-step
      #planNameStep
      [(ngModel)]="FormModel.planNameStep"
      (restoreOnce)="restoreOnceHandler($event)"
      (copyPlan)="handleCopyRAWPlan()"
      [planTypeText]="planTypeText"></mbs-plan-name-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.storage"
    [title]="'wizards:whereBackup.where_backup_title' | i18next"
    [valid]="FormModel?.whereBackupStep?.valid"
    (next)="whereBackupStep?.forceValid()">
    <mbs-where-backup-step
      #whereBackupStep
      [(ngModel)]="FormModel.whereBackupStep"
      (changeStorage)="storageManager.changeStorageHandler($event)"
      [Storages]="FormModel?.Storages"></mbs-where-backup-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectComputer"
    [title]="'wizards:computers_to_restore_title' | i18next"
    [valid]="FormModel?.computerToRestoreStep?.valid"
    (next)="computerToRestore?.forceValid()">
    <mbs-select-computer-step
      #computerToRestore
      [stepFocused]="stepsManager.currentStep?.title === ('wizards:computers_to_restore_title' | i18next)"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      (loadInfo)="loadInfoHandler($event)"
      [(ngModel)]="FormModel.computerToRestoreStep"></mbs-select-computer-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectBackup"
    [title]="'wizards:backupToRestoreTitle' | i18next"
    [valid]="FormModel?.backupToRestoreStep?.valid">
    <mbs-backup-to-restore-step
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      (loadInfo)="loadInfoHandler($event)"
      [(ngModel)]="FormModel.backupToRestoreStep"></mbs-backup-to-restore-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectPoint"
    [title]="restorePointTitle"
    [valid]="FormModel?.restorePointStep?.valid"
    (next)="restorePointStep?.forceValid(stepsManager.currentStep)">
    <mbs-restore-point-step
      #restorePointStep
      (loadInfo)="loadInfoHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'restorePointStep', restorePointTitle)"
      [bunchId]="FormModel?.backupToRestoreStep?.selectedBunch"
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [(ngModel)]="FormModel.restorePointStep"></mbs-restore-point-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.source"
    [title]="'wizards:restore_source_title' | i18next"
    [valid]="FormModel?.restoreSourceStep?.valid"
    (next)="restoreSourceStep?.forceValid()">
    <mbs-restore-source-step
      #restoreSourceStep
      (loadInfo)="loadInfoHandler($event)"
      [(ngModel)]="FormModel.restoreSourceStep"
      [bunchId]="FormModel?.backupToRestoreStep?.selectedBunch"
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      [isVirtual]="FormModel?.typeDataStep?.restoreAs === restoreAsDiskEnum.Virtual"
      [manually]="FormModel?.restorePointStep?.restoreType === restoreType.Manually"
      [resultPoint]="FormModel?.restorePointStep?.resultPoint"
      [stepFocused]="stepsManager.currentStep?.title === ('wizards:restore_source_title' | i18next)"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"></mbs-restore-source-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.typeOfData"
    [title]="'wizards:typeData.title' | i18next"
    [valid]="FormModel?.typeDataStep?.valid"
    (next)="typeDataStep?.forceValid(stepsManager.currentStep)">
    <mbs-type-data-step
      #typeDataStep
      (restoreAsChange)="restoreAsChangeHandler($event)"
      [(ngModel)]="FormModel.typeDataStep"
      [selectedComputersCount]="FormModel.restoreSourceStep?.folders?.length"
      [stepFocused]="stepsManager.currentStep?.title === ('wizards:typeData.title' | i18next)"
      [fileFormats]="FormModel.fileFormats"></mbs-type-data-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    *ngIf="FormModel?.typeDataStep?.restoreAs !== restoreAsDiskEnum.Virtual && isNBF"
    [documentationLink]="helpLink.links.disks"
    [title]="'wizards:restoreDisks.title' | i18next"
    [valid]="FormModel?.restoreDisksStep?.valid"
    (next)="restoreDisksStep?.forceValid()">
    <mbs-restore-disks-step
      #restoreDisksStep
      [(ngModel)]="FormModel.restoreDisksStep"
      [bunchId]="FormModel?.backupToRestoreStep?.selectedBunch"
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      [manually]="FormModel?.restorePointStep?.restoreType === restoreType.Manually"
      [resultPoint]="FormModel?.restorePointStep?.resultPoint"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"></mbs-restore-disks-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.destination"
    [title]="'wizards:destinationOld.dest_step_title' | i18next"
    [valid]="FormModel?.destinationStep?.valid"
    (next)="destinationStep?.forceValid(stepsManager.currentStep)">
    <mbs-destination-vm-step
      #destinationStep
      [canLoadMachines]="
        stepsManager.currentStep?.title === ('wizards:typeData.title' | i18next) ||
        stepsManager.currentStep?.title === ('wizards:restoreDisks.title' | i18next)
      "
      [isVirtual]="FormModel?.typeDataStep?.restoreAs === restoreAsDiskEnum.Virtual"
      [importVirtualMachine]="FormModel?.typeDataStep?.restoreAs === restoreAsDiskEnum.RestoreToHyperVAndImport"
      [(ngModel)]="FormModel.destinationStep"></mbs-destination-vm-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    *ngIf="!isNBF || FormModel?.restorePointStep?.resultPoint?.IsEncrypted || FormModel?.restorePointStep?.resultPoint?.isEncrypted"
    [documentationLink]="helpLink.links.encryption"
    [title]="stepsManager.titles.encryptionOption"
    [valid]="FormModel?.encryptionOptionsStep?.valid"
    (next)="encryptionOptionsStep?.forceValid(stepsManager.currentStep)">
    <mbs-encryption-options-step
      #encryptionOptionsStep
      (loadInfo)="loadInfoHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'encryptionOptionsStep', stepsManager.titles.encryptionOption)"
      [backupToRestore]="FormModel?.backupToRestoreStep?.selectedBunch"
      [resultPoint]="FormModel?.restorePointStep?.resultPoint"
      [(ngModel)]="FormModel.encryptionOptionsStep"></mbs-encryption-options-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    *ngIf="FormModel.planNameStep.SavePlanInCloud"
    [documentationLink]="helpLink.links.schedule"
    [title]="stepsManager.titles.schedule"
    [valid]="FormModel?.scheduleStep?.valid"
    (next)="scheduleStep?.forceValid(stepsManager.currentStep)">
    <mbs-schedule-step
      #scheduleStep
      [(ngModel)]="FormModel.scheduleStep"
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
      [isGFSMode]="isGFSMode"
      [retentionTitle]="stepsManager.titles.retention"
      (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
      (registerRequiredStep)="stepsManager.stepQueue.registerRequiredStep($event)"
      (unregisterRequiredStep)="stepsManager.stepQueue.unregisterRequiredStep($event)"
      (changeType)="scheduleTypeChangeHandler($event)"></mbs-schedule-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="FormModel?.scheduleStep?.ScheduleType === 'recurring'"
    [documentationLink]="helpLink.links.schedule"
    [title]="'wizards:advanced_schedule_restore_title' | i18next"
    [valid]="FormModel.scheduleAdvancedStep.valid"
    (next)="scheduleAdvancedStep?.forceValid()">
    <mbs-schedule-advanced-step
      #scheduleAdvancedStep
      [(ngModel)]="FormModel.scheduleAdvancedStep"></mbs-schedule-advanced-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="mainService.allowPrePostActions | async"
    [documentationLink]="helpLink.links.prePost"
    [title]="
      (mainService.allowPrePostActions | async) ? ('wizards:pre_post_title' | i18next) : ('wizards:pre_post_title_backup_chain' | i18next)
    "
    [valid]="FormModel?.prePostActionsStep?.valid"
    (next)="prePostActionsStep?.forceValid()">
    <mbs-pre-post-actions-step
      #prePostActionsStep
      [(ngModel)]="FormModel.prePostActionsStep"
      [ChainPlans]="FormModel?.AvailableMachinePlans"></mbs-pre-post-actions-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="!isRDMode"
    [documentationLink]="helpLink.links.notification"
    [title]="'wizards:notification_step_title' | i18next"
    [valid]="FormModel?.notificationStep?.valid">
    <mbs-notifications-step
      [(ngModel)]="FormModel.notificationStep"
      (notificationChange)="notificationChangeHandler($event)"
      [notification]="mainService.planNotification"></mbs-notifications-step>
  </mbs-wizard-step>
</mbs-wizard>
